import authenticated from './http-clients/authenticated'

const _url = '/config'

export default {
  index () {
    return authenticated({
      url: _url,
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/config.js